import React, { useEffect, useState } from "react";
import "../css/Changelog.css";
import axios from "axios";
import { GoldLoader } from "../shared/Loaders";

const CrmChangeLog = () => {
  const [changelogs, setChangelogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    axios
      // ✅ Correct endpoint
      .get(`${API_URL}/changelogs?module=crm`)
      .then((res) => {
        const data = res.data || [];
        setChangelogs(Array.isArray(data) ? data : []);
      })
      .catch((err) => console.error("Failed to fetch CRM changelogs", err))
      .finally(() => setLoading(false));
  }, [API_URL]);

  const formatValue = (val) => {
    if (val === null || val === undefined) return "-";
    if (typeof val === "object") return JSON.stringify(val);
    return String(val);
  };

  if (loading) {
    return <GoldLoader label="Loading..." variant="page" />;
  }

  return (
    <div className="crm-list-page changelog-wrapper">
      <div className="crm-list-toolbar" />
      <div className="changelog-table-container">
        <table className="igf-changelog-table">
          <thead>
            <tr>
              <th>Person</th>
              <th>Organization</th>
              <th>Updated On</th>
              <th>Updated By</th>
              <th>Field</th>
              <th>Previous</th>
              <th>New</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7">
                  <GoldLoader label="Loading..." variant="section" />
                </td>
              </tr>
            ) : changelogs.length > 0 ? (
              changelogs.map((log, index) => (
                <tr key={index}>
                  <td>
                    {log.edited_person_id
                      ? `${log.edited_person_id.name || ""} ${log.edited_person_id.lname || ""}`
                      : "-"}
                  </td>

                  <td>{log.edited_org_id?.name || "-"}</td>

                  <td>
                    {log.updated_on
                      ? new Date(log.updated_on).toLocaleString()
                      : "-"}
                  </td>

                  <td>
                    {log.edited_by_admin?.username ||
                      [log.edited_by_person?.name, log.edited_by_person?.lname].filter(Boolean).join(" ").trim() ||
                      log.edited_by_person?.email ||
                      "-"}
                  </td>

                  <td className="field-name">{log.field || "-"}</td>

                  <td className="value-cell">
                    {formatValue(log.prev_value)}
                  </td>

                  <td className="value-cell">
                    {formatValue(log.new_value)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="no-data">
                  No CRM changelog data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CrmChangeLog;